(function () {
  'use strict';
  var timers = Array.prototype.slice.call(document.querySelectorAll('[data-fn-campaign-expires]'));
  function tick() {
    var now = Date.now();
    timers.forEach(function (root) {
      var end = Number(root.getAttribute('data-fn-campaign-expires')) * 1000;
      if (!Number.isFinite(end)) return;
      var seconds = Math.max(0, Math.ceil((end - now) / 1000));
      if (seconds <= 0) { root.hidden = true; root.setAttribute('aria-hidden', 'true'); return; }
      var days = Math.floor(seconds / 86400);
      var hours = Math.floor(seconds % 86400 / 3600);
      var minutes = Math.floor(seconds % 3600 / 60);
      var text = days + (days === 1 ? ' dag ' : ' dage ')
        + hours + (hours === 1 ? ' time ' : ' timer ')
        + minutes + (minutes === 1 ? ' minut' : ' minutter');
      root.querySelectorAll('[data-fn-campaign-clock]').forEach(function (clock) { clock.textContent = text; });
      var segs = { d: days, h: hours, m: minutes, s: seconds % 60 };
      root.querySelectorAll('[data-fn-seg]').forEach(function (seg) {
        var value = segs[seg.getAttribute('data-fn-seg')];
        seg.textContent = value < 10 ? '0' + value : String(value);
      });
    });
  }
  tick();
  var timer = setInterval(tick, 1000);
  document.addEventListener('visibilitychange', tick);
  window.addEventListener('pagehide', function () { clearInterval(timer); });
  window.addEventListener('pageshow', function (event) { if (event.persisted) { tick(); timer = setInterval(tick, 1000); } });
  var offers = Array.prototype.slice.call(document.querySelectorAll('[data-fn-campaign-code]'));
  var pageUrl = new URL(window.location.href);
  var requestedCode = pageUrl.searchParams.get('fn_campaign_applied');
  var scrollTarget = null;
  function current(root) {
    return !root.hidden && Number(root.getAttribute('data-fn-campaign-expires')) * 1000 > Date.now();
  }
  function setStatus(root, text, failed) {
    var status = root.querySelector('[data-fn-campaign-status]');
    if (!status || !current(root)) return;
    status.textContent = text;
    status.hidden = false;
    status.classList.toggle('fn-code-campaign__status--error', !!failed);
    if (requestedCode === root.getAttribute('data-fn-campaign-code') && root.offsetParent !== null && !root.closest('#CartDrawer') && !scrollTarget) scrollTarget = status;
  }
  function scrollToStatus() {
    if (scrollTarget) scrollTarget.scrollIntoView({ block: 'center', behavior: 'auto' });
  }
  function clearMarker() {
    if (!requestedCode) return;
    pageUrl.searchParams.delete('fn_campaign_applied');
    window.history.replaceState(window.history.state, '', pageUrl.pathname + pageUrl.search + pageUrl.hash);
  }
  if (offers.some(current)) {
    offers.forEach(function (root) {
      if (requestedCode === root.getAttribute('data-fn-campaign-code')) setStatus(root, 'Vi kontrollerer din rabatkode …', false);
    });
    var cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(cartRoot + 'cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (response) { if (!response.ok) throw new Error('Cart unavailable'); return response.json(); })
      .then(function (cart) {
        var codes = Array.isArray(cart.discount_codes) ? cart.discount_codes : [];
        offers.forEach(function (root) {
          if (!current(root)) return;
          var code = root.getAttribute('data-fn-campaign-code');
          var saved = codes.some(function (entry) { return String(entry.code).toUpperCase() === code.toUpperCase(); });
          if (saved) {
            var percent = root.getAttribute('data-fn-campaign-percent');
            setStatus(root, 'Rabatkoden ' + code + ' er gemt. Rabatten på ' + percent + ' % bliver automatisk fratrukket i checkout på numre til normalpris. Du skal ikke indtaste koden igen.', false);
            var hint = root.querySelector('[data-fn-campaign-hint]');
            if (hint) hint.hidden = true;
            var apply = root.querySelector('.fn-code-campaign__apply');
            if (apply) apply.textContent = 'Rabatkode klar';
          } else if (requestedCode === code) {
            setStatus(root, 'Vi kunne ikke bekræfte rabatkoden. Prøv “Brug rabatkoden” igen, eller indtast ' + code + ' i checkout.', true);
          }
        });
        clearMarker();
        scrollToStatus();
      }).catch(function () {
        offers.forEach(function (root) {
          if (requestedCode === root.getAttribute('data-fn-campaign-code')) setStatus(root, 'Vi kunne ikke bekræfte rabatkoden. Indtast ' + root.getAttribute('data-fn-campaign-code') + ' i checkout.', true);
        });
        clearMarker();
        scrollToStatus();
      });
  }
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-fn-copy-code]');
    if (!button) return;
    var code = button.getAttribute('data-fn-copy-code');
    var label = button.querySelector('[data-fn-copy-label]');
    if (!label) return;
    function feedback(copied) {
      label.textContent = copied ? 'Kopieret' : 'Markér og kopiér koden';
      setTimeout(function () { label.textContent = 'Kopiér kode'; }, 2500);
    }
    function fallback() {
      var input = document.createElement('textarea'), focused = document.activeElement, copied = false;
      input.value = code;
      input.setAttribute('readonly', '');
      input.setAttribute('aria-hidden', 'true');
      input.style.cssText = 'position:fixed;top:0;left:-9999px';
      document.body.appendChild(input);
      input.select();
      input.setSelectionRange(0, code.length);
      try { copied = document.execCommand('copy'); } catch (error) { /* show manual-copy hint */ }
      input.remove();
      if (focused && focused.focus) focused.focus({ preventScroll: true });
      feedback(copied);
    }
    if (!navigator.clipboard || !navigator.clipboard.writeText) { fallback(); return; }
    navigator.clipboard.writeText(code).then(function () { feedback(true); }).catch(fallback);
  });
})();
